import { HttpError } from '../../types';

export const handleError = async <T>(res: Response): Promise<T> => {
  const responsePromise = res.json().then((error) => Promise.reject(error as HttpError));
  return responsePromise.catch().then(() =>
    res.text().then((error) =>
      Promise.reject({
        error,
        errors: [error],
        status: res.status,
        title: '',
        traceId: '',
        type: res.statusText,
      } as unknown as HttpError)
    )
  );
};
